<template>
  <main>
    <PolicyHeader/>
    <background-wrapper src="policy-footer" ext="png">
      <container-small class="py-6">
        <b-card>
          <h2 class="pb-2" v-html="$t(`${$route.name}.body.title`)"/>
          <div class="text" v-html="$t(`${$route.name}.body.text`)"/>
        </b-card>
      </container-small>
    </background-wrapper>
  </main>
</template>

<script>
import { PolicyHeader } from '@/components/ui'
export default {
  name: 'Security',
  components: {
    PolicyHeader
  }
}
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/security/Security.vue